import { ReactNode } from 'react';

type ColumnDefinitionProps<T extends object> = {
  property: keyof T;
  label: string | (() => JSX.Element);
  order?: number;
  sortable?: boolean;
  render?: (row: {
    [K in keyof T]: T[K];
  }) => ReactNode;
  width?: string;
};

function ColumnDefinition<T extends object>(
  _props: ColumnDefinitionProps<T>
): JSX.Element {
  return <></>;
}

export { ColumnDefinition, ColumnDefinitionProps };
